import React from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonBlock from 'blocks/ButtonBlock';
import ImageBlock from 'blocks/ImageBlock';
import FormStackBlock from 'components/FormStackBlock/FormStackBlock';
import PageHeader from 'components/PageHeader/PageHeader';
import PageStackBlock from 'components/PageStackBlock/PageStackBlock';

const OfferBooksScreen = ({ onSubmit }: { onSubmit: (value: string) => void }) => (
  <PageStackBlock>
    <PageHeader headline={<FormattedMessage id="v2 funnel offer books headline" />} text={<FormattedMessage id="v2 funnel offer books info" />} />

    <FormStackBlock>
        <ButtonBlock background="PRIMARY" color="WHITE" onClick={() => onSubmit('yes')}>
          <FormattedMessage id="Yes" />
        </ButtonBlock>
        <ButtonBlock background="SECONDARY_DARK" color="WHITE" onClick={() => onSubmit('no')}>
          <FormattedMessage id="No" />
        </ButtonBlock>
    </FormStackBlock>

    <ImageBlock fullWidth={true}>
      <img src="/images/funnels/quizfunnel-book.jpg" width="100%" alt="" />
    </ImageBlock>
  </PageStackBlock>
);

export default OfferBooksScreen;